// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ════════════════════════════════════════════════════════════════
   VNInvestCharts — ChartSplitter default styles
   ────────────────────────────────────────────────────────────────
   Minimalist: invisible until hover, then bright accent line.
   Override colours via --vnsc-* CSS custom properties.
════════════════════════════════════════════════════════════════ */

.vnsc-splitter,
.rsc-splitter {
  position: absolute;
  left: 0;
  right: 0;
  height: 18px;
  margin-top: -9px;
  cursor: row-resize;
  z-index: 12;
  pointer-events: auto;
  user-select: none;
  touch-action: none;
}

/* Splitter line — invisible by default, appears on hover */
.vnsc-splitter::after,
.rsc-splitter::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 2px;
  background: transparent;
  transition: background 0.15s;
}

/* On hover or drag: bright accent line */
.vnsc-splitter:hover::after,
.vnsc-splitter--dragging::after,
.rsc-splitter:hover::after,
.rsc-splitter--dragging::after {
  background: var(--vnsc-accent, #2962ff);
}

.rsc-splitter__badge {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: rgba(20, 20, 28, 0.85);
  color: #fff;
  font: 11px/1 sans-serif;
  padding: 3px 8px;
  border-radius: 10px;
  pointer-events: none;
  white-space: nowrap;
}

/* Suppress ugly focus rectangle on mouse click — keep only accent line for a11y */
.rsc-splitter:focus {
  outline: none;
}
.rsc-splitter:focus-visible {
  outline: none;
}
.rsc-splitter:focus-visible::after {
  background: var(--vnsc-accent, #2962ff);
}

@media (pointer: coarse) {
  .vnsc-splitter,
  .rsc-splitter {
    height: 24px;
    margin-top: -12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/widget/styles/chart-splitter.css"],"names":[],"mappings":"AAAA;;;;;kEAKkE;;AAElE;;EAEE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,2DAA2D;AAC3D;;EAEE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA,yCAAyC;AACzC;;;;EAIE,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,kCAAkC;EAClC,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,kFAAkF;AAClF;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,uCAAuC;AACzC;;AAEA;EACE;;IAEE,YAAY;IACZ,iBAAiB;EACnB;AACF","sourcesContent":["/* ════════════════════════════════════════════════════════════════\r\n   VNInvestCharts — ChartSplitter default styles\r\n   ────────────────────────────────────────────────────────────────\r\n   Minimalist: invisible until hover, then bright accent line.\r\n   Override colours via --vnsc-* CSS custom properties.\r\n════════════════════════════════════════════════════════════════ */\r\n\r\n.vnsc-splitter,\r\n.rsc-splitter {\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  height: 18px;\r\n  margin-top: -9px;\r\n  cursor: row-resize;\r\n  z-index: 12;\r\n  pointer-events: auto;\r\n  user-select: none;\r\n  touch-action: none;\r\n}\r\n\r\n/* Splitter line — invisible by default, appears on hover */\r\n.vnsc-splitter::after,\r\n.rsc-splitter::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  height: 2px;\r\n  background: transparent;\r\n  transition: background 0.15s;\r\n}\r\n\r\n/* On hover or drag: bright accent line */\r\n.vnsc-splitter:hover::after,\r\n.vnsc-splitter--dragging::after,\r\n.rsc-splitter:hover::after,\r\n.rsc-splitter--dragging::after {\r\n  background: var(--vnsc-accent, #2962ff);\r\n}\r\n\r\n.rsc-splitter__badge {\r\n  position: absolute;\r\n  left: 50%;\r\n  top: 50%;\r\n  transform: translate(-50%, -50%);\r\n  background: rgba(20, 20, 28, 0.85);\r\n  color: #fff;\r\n  font: 11px/1 sans-serif;\r\n  padding: 3px 8px;\r\n  border-radius: 10px;\r\n  pointer-events: none;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Suppress ugly focus rectangle on mouse click — keep only accent line for a11y */\r\n.rsc-splitter:focus {\r\n  outline: none;\r\n}\r\n.rsc-splitter:focus-visible {\r\n  outline: none;\r\n}\r\n.rsc-splitter:focus-visible::after {\r\n  background: var(--vnsc-accent, #2962ff);\r\n}\r\n\r\n@media (pointer: coarse) {\r\n  .vnsc-splitter,\r\n  .rsc-splitter {\r\n    height: 24px;\r\n    margin-top: -12px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
